"use strict";
/**
 * Copyright (c) 2024 BrightSpike
 * All rights reserved.
 *
 * This source code is unlicensed.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * For detailed license information, please contact Brightspike at (info@brightspike.io).
 * @author Austin Weidler
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpeedSprite = void 0;
const pixi_js_1 = require("pixi.js");
const Global_1 = require("../Global");
const brushspeed_svg_1 = __importDefault(require("../../assets/svg/brushspeed.svg"));
const gsap_core_1 = require("gsap/gsap-core");
const squiggle_svg_1 = __importDefault(require("../../assets/svg/squiggle.svg"));
const blocks_1 = require("../blocks");
const settings_1 = require("../config/settings");
class SpeedSprite extends blocks_1.Block {
    constructor(app, repeats = -1) {
        super(app);
        this.repeats = repeats;
        this.speedSprite = pixi_js_1.Sprite.from(brushspeed_svg_1.default);
        this.speedSprite.anchor.set(0.5);
        this.addChild(this.speedSprite);
        this.tm = gsap_core_1.gsap.timeline({ repeat: repeats, paused: true });
        this.tm2 = gsap_core_1.gsap.timeline({ repeat: repeats, paused: true, yoyo: true });
        this.tm3 = gsap_core_1.gsap.timeline({ repeat: repeats, paused: true });
        this.tm2.to(this.speedSprite, {
            pixi: {
                rotation: 2
            },
            duration: 0.1
        });
        this.squiggles = [pixi_js_1.Sprite.from(squiggle_svg_1.default), pixi_js_1.Sprite.from(squiggle_svg_1.default), pixi_js_1.Sprite.from(squiggle_svg_1.default)];
        for (let i = 0; i < this.squiggles.length; i++) {
            const squiggleSprite = this.squiggles[i];
            squiggleSprite.anchor.set(1.0, 0.5);
            this.addChild(squiggleSprite);
            this.tm3.to(squiggleSprite, {
                pixi: {
                    tint: settings_1.Settings.negativeColor
                },
                duration: 0.5
            }, '>-0.9')
                .to(squiggleSprite, {
                pixi: {
                    tint: settings_1.Settings.whiteColor
                },
                duration: 0.5
            });
            // Will update values in layout
            this.tm.to(squiggleSprite, {
                id: 's1_' + i,
                pixi: {},
                duration: 0.08,
                ease: 'none'
            }, 'forth')
                .to(squiggleSprite, {
                id: 's2_' + i,
                pixi: {},
                duration: 0.08,
                ease: 'none'
            }, 'back');
        }
        this.tms.add(this.tm).add(this.tm2).add(this.tm3);
        this.layout();
    }
    reset() {
        this.tms.forEach((t) => {
            t.vars.repeat = this.repeats;
            t.seek(0);
        });
    }
    play() {
        this.tms.forEach((t) => t === null || t === void 0 ? void 0 : t.restart());
    }
    pause() {
        this.tms.forEach((t) => t === null || t === void 0 ? void 0 : t.pause());
    }
    stop() {
        this.tms.forEach((t) => t === null || t === void 0 ? void 0 : t.pause(0));
    }
    layout() {
        super.layout();
        this.speedSprite.scale.set((0, Global_1.px)(this.overSmallSize ? 0.4 : 0.3));
        const padx = (0, Global_1.px)(this.overSmallSize ? 9 : 7);
        const pady = (0, Global_1.px)(this.overSmallSize ? -19 : -16);
        this.squiggles.forEach((squiggleSprite, i) => {
            const scale = (0, Global_1.px)(this.overSmallSize ? 0.25 : 0.23);
            squiggleSprite.scale.set(scale);
            squiggleSprite.position.set(padx + i * (0, Global_1.px)(-12), pady + i * (0, Global_1.px)(this.overSmallSize ? 11 : 9));
            this.tm.getById('s1_' + i).vars.pixi.scaleX = scale * 1.2;
            this.tm.getById('s2_' + i).vars.pixi.scaleX = scale;
        });
    }
}
exports.SpeedSprite = SpeedSprite;
